import React, { FC, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { Button } from 'shared/ui/Button';
import queryString from 'query-string';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { AppRoutes } from 'app/config/routerConfig/types';
import { SuccessScreen } from 'shared/ui/SuccessScreen';
import { useGetCurrencySymbol } from 'app/appState';
import { useAppSelector } from 'app/config/storeConfig/hooks';
import { getGlobalSettings } from 'app/appState/model/selectors/getGlobalSettings';
import { getPurchaseEventId, trackFacebookEvent } from 'shared/utils/helpers/facebookPixel';

export const PaymentSuccessPage: FC = () => {
  const { amount, invoiceId } = queryString.parse(window.location.search);

  const navigate = useNavigate();
  const { t } = useAppTranslation('booking');
  const globalSettings = useAppSelector(getGlobalSettings);

  const goToHomePage = (): void => {
    navigate(AppRoutes.HOME);
  };

  const currencySymbol = useGetCurrencySymbol();

  useEffect(() => {
    // Дубль Purchase на стороне браузера — необязателен (источник истины это
    // CAPI из вебхука оплаты на бэке), но помогает, если пиксель у клиента
    // работает лучше, чем сервер-сервер соединение. event_id общий с бэком,
    // Facebook сам склеит два события в одно.
    if (typeof invoiceId === 'string') {
      trackFacebookEvent('Purchase', getPurchaseEventId(invoiceId), {
        value: amount,
        currency: globalSettings?.currency,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="p-[100px]">
      <SuccessScreen
        title={t('Congratulations!')}
        description={t('Box has been successfully reserved')}
        additionalInfo={
          amount ? (
            <div className="mb-10 text-primaryLight flex justify-between">
              <div className="text-lg">{t('Amount Paid:')}</div>
              <div className="font-semibold">
                {amount} {currencySymbol}
              </div>
            </div>
          ) : undefined
        }
        actions={
          <Button onClick={goToHomePage} size="large" containerClassName="w-full">
            {t('Home')}
          </Button>
        }
      />
    </div>
  );
};
